import { render, staticRenderFns } from "./lucky-draw-item.vue?vue&type=template&id=d6353254&scoped=true&"
import script from "./lucky-draw-item.vue?vue&type=script&lang=js&"
export * from "./lucky-draw-item.vue?vue&type=script&lang=js&"
import style0 from "./lucky-draw-item.vue?vue&type=style&index=0&id=d6353254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6353254",
  null
  
)

export default component.exports